import { useDispatch, useSelector } from 'react-redux'
import { updateStep } from '../../redux/slices/meta'
import { RootState } from '../../redux/store'
import { UserInfoType } from '../../types/state'
import {
	ProgressBarWrapper,
	ProgressBarStep,
	PageOf,
	BackButton,
	Image,
	PageWrapper,
} from './style'
import backIcon from '../../asset/back.png'
const ProgressBar = () => {
	const dispatch = useDispatch()
	const metaData = useSelector((state: RootState) => state.meta)
	const position = Object.keys(UserInfoType).indexOf(
		metaData.userInfoStep.toUpperCase()
	)

	const goBack = () => {
		if (position == 1) {
			dispatch(updateStep(UserInfoType.REGINAL_LANGUAGE_PROFICIENCY))
		}
		if (position == 2) {
			dispatch(updateStep(UserInfoType.NAME))
		}
		if (position === 3) {
			dispatch(updateStep(UserInfoType.EMAIL))
		}
		if (position === 4) {
			dispatch(updateStep(UserInfoType.DOB))
		}
		if (position === 5) {
			dispatch(updateStep(UserInfoType.GENDER))
		}
		if (position === 6) {
			dispatch(updateStep(UserInfoType.EDUCATION))
		}
		if (position === 7) {
			dispatch(updateStep(UserInfoType.STATE))
		}
		if (position === 8) {
			dispatch(updateStep(UserInfoType.CITY))
		}
	}
	return (
		<>
			<ProgressBarWrapper>
				{[...Array(5)].map((item, index) => {
					return (
						<ProgressBarStep
							key={index}
							isActive={index <= position}
						></ProgressBarStep>
					)
				})}
			</ProgressBarWrapper>
			<PageWrapper>
				<BackButton
					onClick={goBack}
					isVisible={position === 0 ? false : true}
				>
					<Image src={backIcon} />
				</BackButton>

				<PageOf>{position + 1} of 8</PageOf>
			</PageWrapper>
		</>
	)
}
export default ProgressBar
